import { OnDestroy, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import english from './i18n/en.json';
import spanish from './i18n/es.json';
import portuguese from './i18n/pt.json';
var FcDateInputComponent = /** @class */ (function () {
    function FcDateInputComponent(fuseTranslationLoaderService) {
        this.fuseTranslationLoaderService = fuseTranslationLoaderService;
        this.fixedColor = true;
        this.removeSubscriptions = new Subject();
        this.fuseTranslationLoaderService.loadJsonTranslations({ english: english, portuguese: portuguese, spanish: spanish });
    }
    FcDateInputComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.updateColorIcon();
        this.control.valueChanges.pipe(takeUntil(this.removeSubscriptions)).subscribe(function () {
            _this.updateColorIcon();
        });
    };
    FcDateInputComponent.prototype.ngOnDestroy = function () {
        this.removeSubscriptions.next();
        this.removeSubscriptions.complete();
    };
    FcDateInputComponent.prototype.updateColorIcon = function () {
        this.colorIcon = this.control.valid && this.control.value !== null;
    };
    return FcDateInputComponent;
}());
export { FcDateInputComponent };
